var UIAlertToggle = (function ($) {

    UIAlertToggle = function () {
        var that = this;

        // DOM

        // CONST
        that.class = {
            close: 'close',
        };

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UIAlertToggle.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UIAlertToggle.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('click', '.alert.toggle', function (e) {
            var $alert = $(this),
                $alert_toggle_icon = $alert.find('.js-alert-toggle-icon'),
                $alert_toggle_box = $alert.find('.js-alert-toggle-box');

            if (!$alert_toggle_icon.length || !$alert_toggle_box.length) {
                return false;
            }

            var $target = $(e.target),
                is_toggle = $target.hasClass('js-alert-toggle-box') || $target.parents('.js-alert-toggle-box').length ?? false;
            
            if (!is_toggle) {
                $alert_toggle_box.slideToggle(function () {
                    $alert.toggleClass(that.class.close);
                });
            }
        });
    };

    return UIAlertToggle;
})($);
